import { render } from "./AqsiIntegration.vue?vue&type=template&id=35f38860"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/AqsiIntegration.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35f38860"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35f38860', __exports__)) {
    api.reload('35f38860', __exports__)
  }
  
  module.hot.accept("./AqsiIntegration.vue?vue&type=template&id=35f38860", () => {
    api.rerender('35f38860', render)
  })

}


export default __exports__